module.exports = __webpack_public_path__ + "img/1.10b51698.jpg";